export const environment = {
    production: false,
    apiPath: 'https://schooladminportal.com/spectrum-api',
    externalApiPath: 'https://schooladminportal.com/spectrum-api',
    authBaseUrl: 'https://schooladminportal.com',
    /** See environment.ts — the module's own deploy path, not the bare origin. */
    paymentLinkBaseUrl: 'https://schooladminportal.com/Spectrum/finance-v2'
};
